var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Type = require("./modules/Type.js");

var RangeContainer = require("./modules/rangeContainer.js");

var NUMBER = 'NUMBER';
var LOWER = 'LOWER';
var UPPER = 'UPPER';
var algorithms = {
  alphaNumeric: [1, 2, 3],
  alphaNumericLowerCase: [1, 3],
  alpha: [2, 3],
  alphaLower: [3],
  alphaUpper: [2],
  numeric: [1]
};
var rangeContainer = new RangeContainer([new Type(NUMBER, 1, 48, 57), new Type(UPPER, 2, 65, 90), new Type(LOWER, 3, 97, 122)]);

module.exports = /*#__PURE__*/function () {
  "use strict";

  function Random() {
    _classCallCheck(this, Random);
  }

  _createClass(Random, null, [{
    key: "chooseChar",
    value: function chooseChar(ranNum) {
      return String.fromCharCode(ranNum);
    }
  }, {
    key: "chooseNum",
    value: function chooseNum(_ref) {
      var min = _ref.min,
          max = _ref.max;
      return Math.floor(Math.random() * (max - min) + min);
    }
  }, {
    key: "generate",
    value: function generate(length, algorithm) {
      var id = '';

      while (length--) {
        var config = algorithms[algorithm];
        var range = rangeContainer.selectRange(config);
        var randomNumber = this.chooseNum(range);
        var character = this.chooseChar(randomNumber);
        id += character;
      }

      return id;
    }
  }, {
    key: "RandomBetween",
    value: function RandomBetween(min, max) {
      return Random.chooseNum({
        min: min,
        max: max
      });
    }
  }, {
    key: "randomStringAlphaNumeric",
    value: function randomStringAlphaNumeric(length) {
      return Random.generate(length, "alphaNumeric");
    }
  }, {
    key: "randomStringAlphaNumericLower",
    value: function randomStringAlphaNumericLower(length) {
      return Random.generate(length, "alphaNumericLowerCase");
    }
  }, {
    key: "randomStringLowerCase",
    value: function randomStringLowerCase(length) {
      return Random.generate(length, "alphaLower");
    }
  }, {
    key: "randomStringUpperCase",
    value: function randomStringUpperCase(length) {
      return Random.generate(length, "alphaUpper");
    }
  }, {
    key: "randomStringMixedCase",
    value: function randomStringMixedCase(length) {
      return Random.generate(length, "alpha");
    }
  }, {
    key: "randomStringNumeric",
    value: function randomStringNumeric(length) {
      return Random.generate(length, "numeric");
    }
  }]);

  return Random;
}();